import { render, staticRenderFns } from "./hrd-add-course.vue?vue&type=template&id=464c3c12&scoped=true"
import script from "./hrd-add-course.vue?vue&type=script&lang=js"
export * from "./hrd-add-course.vue?vue&type=script&lang=js"
import style0 from "./hrd-add-course.vue?vue&type=style&index=0&id=464c3c12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464c3c12",
  null
  
)

export default component.exports